import { NavLink } from "react-router-dom";
import { ROUTES } from "@/app/routes";
import { IconRenderer } from "@/components/icons/IconRenderer";
import { usePublicLegalPages } from "@/features/legal-pages/hooks";
import { usePublicSocialLinks } from "@/features/social-links/hooks";
import { useSiteSettings } from "@/features/site-settings/hooks";

const legalLinks = [
  { label: "Terms", to: ROUTES.terms },
  { label: "Privacy", to: ROUTES.privacy },
  { label: "Terms of Use", to: ROUTES.termsOfUse },
  { label: "Disclaimer", to: ROUTES.disclaimer },
];

export function Footer() {
  const siteSettings = useSiteSettings();
  const socials = usePublicSocialLinks();
  const legalPages = usePublicLegalPages();
  const year = new Date().getFullYear();
  const siteName = siteSettings.data?.siteName ?? "Kalaco's Liveries";
  const links = legalPages.data?.length
    ? legalPages.data.map((page) => ({ label: page.title, to: `/${page.slug}` }))
    : legalLinks;

  return (
    <footer className="border-t border-cyan-300/15 bg-ink/80">
      <div className="mx-auto flex max-w-7xl flex-col gap-5 px-3 py-8 sm:px-6 md:flex-row md:items-center md:justify-between lg:px-8">
        <div className="min-w-0">
          <p className="break-words text-sm text-content-muted">Copyright {year} {siteName}. All rights reserved.</p>
          <div className="mt-3 flex flex-wrap gap-2">
            {(socials.data ?? []).map((link) => (
              <a key={link.id} href={link.url} target="_blank" rel="noreferrer" className="grid size-8 place-items-center rounded border border-cyan-300/20 text-xs text-content-secondary hover:text-white" aria-label={link.label || link.platform}>
                <IconRenderer value={link.iconName} iconSet="social" />
              </a>
            ))}
          </div>
        </div>
        <nav className="flex min-w-0 flex-wrap gap-3">
          {links.map((link) => (
            <NavLink key={link.to} to={link.to} className="text-sm text-content-secondary hover:text-white">
              {link.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </footer>
  );
}
